/**
 * Brazilian Portuguese (pt-BR) mappings for DesktopNavigation
 */

export const desktopNavigationPtBR = {
  // Brand name (keep as is)
  "PickStar": "PickStar",
  
  // Navigation items
  "Home": "Início",
  "Chat": "Conversa",
  "AI Exchange": "Câmbio de IA",
  "Sports Hub": "Central de Esportes",
  "Upgrade": "Atualizar",
  "Settings": "Configurações",
  "Chat Archive": "Arquivo de Conversas",
  "About Us": "Sobre Nós",
  "Help": "Ajuda",
  "Sign Out": "Sair",
  "Hide Sidebar": "Ocultar Barra Lateral",
};